import { useEffect, useId, useRef } from "react";

const AD_KEY = "6209c9164a25582ac3b69bee34cc8313";
const AD_SRC = `https://www.highperformanceformat.com/${AD_KEY}/invoke.js`;

type AdWindow = Window & {
  atOptions?: Record<string, unknown>;
  __yawikiAdSlots?: Record<string, boolean>;
};

function staticAdScript(slotId: string) {
  return `
  atOptions = {
    'key' : '${AD_KEY}',
    'format' : 'iframe',
    'height' : 250,
    'width' : 300,
    'params' : {}
  };
  window.__yawikiAdSlots = window.__yawikiAdSlots || {};
  window.__yawikiAdSlots['${slotId}'] = true;
`;
}

export function Ad300x250() {
  const reactId = useId().replace(/:/g, "");
  const slotId = `yawiki-ad-${reactId}`;
  const containerRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    const container = containerRef.current;
    const adWindow = window as AdWindow;

    if (!container || adWindow.__yawikiAdSlots?.[slotId]) return;

    adWindow.atOptions = {
      key: AD_KEY,
      format: "iframe",
      height: 250,
      width: 300,
      params: {}
    };
    adWindow.__yawikiAdSlots = {
      ...(adWindow.__yawikiAdSlots ?? {}),
      [slotId]: true
    };

    const runtimeScript = document.createElement("script");
    runtimeScript.src = AD_SRC;
    runtimeScript.async = true;
    runtimeScript.dataset.runtimeAd = slotId;
    container.appendChild(runtimeScript);
  }, [slotId]);

  return (
    <aside ref={containerRef} className="ad-slot" aria-label="Advertisement">
      <span>Advertisement</span>
      <script data-static-ad={slotId} dangerouslySetInnerHTML={{ __html: staticAdScript(slotId) }} />
      <script data-static-ad={slotId} src={AD_SRC} />
    </aside>
  );
}
